module.exports = "../../../../platform/assets/pageMainIcon/youth_yewuchulilei7.svg";